<template>
  <v-app>
    <AdSmp />
    <div
      id="text-box"
      :class="{textvertical: isVertical,texthorizontal:!isVertical}"
    >
      <p
        :class="`pa-4 mt-4 mx-8 mb-6 grey-text normal-text-area-${fontSizeIndex*1.1}`"
        style="font-weight:bold;background-color: var(--v-background2-base)"
      >
        {{ page.name }}
      </p>
      <p
        :class="`pa-4 mt-4 mx-8 mb-6 grey-text normal-text-area-${fontSizeIndex}`"
        :style="`background-color: var(--v-background2-base); line-height:${lineSpaceSize}em`"
        v-html="preview"
      />
    </div>
  </v-app>
</template>

<script>
import {mapState} from "vuex";
import config from "@/const";
import firebase from "firebase/app";
import axios from "axios";
import AdSmp from '../component/AdSmp.vue';
import rubiConverter from "@/component/rubiConverter";

export default {
  name: "FullSizeTextPreview",
  components: {
    AdSmp,
  },
  computed: {
    ...mapState({
      user: state => state.userModule.user,
      fontSize: state => state.userModule.user.writerFontSizeTypeKeyValue.size * 13,
      fontSizeIndex: state => state.userModule.user.writerFontSizeTypeKeyValue.value,
      lineSpaceSize: state => state.userModule.user.writerLineSpaceTypeKeyValue.size
    }),
  },
  data() {
    return {
      page: {},
      preview: "",
      isVertical: false
    }
  },
  watch: {
    $route: {
      async handler() {
        this.isVertical = this.$route.query.orientation == "vertical"
        const novel = this.$store.state.NovelListModule.NovelList.find(item => item.id == config.HASH_IDS.decode(this.$route.params.novelid)[0])
        if (novel == null) {
          this.$router.push({name: 'Novels'})
        } else {
          this.siteType = config.findSiteType(novel.targetSite);
          const user = firebase.auth().currentUser
          const token = await user.getIdToken(false)
          if (token == null) {
            return
          }
          // console.log("token="+token)
          const ret = await axios.get(config.API_URL + "auth/page", {
            headers: {"X-Firebase-Auth": token},
            params: {
              "id": config.HASH_IDS.decode(this.$route.params.text_id)[0]
            },
            data: {}
          })
          if (!ret.data) {
            this.$router.push({
              name: 'TextEdit',
              params: {novelid: config.HASH_IDS.decode(this.$route.params.novelid)[0], text_id: 'create'}
            })
          } else {
            this.page = ret.data
            if (this.siteType.value == 7)
              this.preview = this.page.content.replaceAll("\n", "<br/>")
            else
              this.preview = rubiConverter.previewRubiConvert(this.escape_html(this.page.content))
          }
          if (this.isVertical) {

            window.addEventListener("mousewheel", event => {
              console.dir("mousewheel...e.deltaX="+event.deltaX +" y="+event.deltaY)
              console.dir(event)

              var delta = 0;
              if (!event) { /* For IE. */
                event = window.event;
              }
              //Shiftキー Cｔｒｌキー押下時
              var altK = typeof event.modifiers == 'undefined' ? event.altKey : event.modifiers & event.ALT_MASK;
              var ctrlK = typeof event.modifiers == 'undefined' ? event.ctrlKey : event.modifiers & event.CONTROL_MASK;
              var shiftK = typeof event.modifiers == 'undefined' ? event.shiftKey : event.modifiers & event.SHIFT_MASK;
              if (shiftK|ctrlK) { return true; }

              if (event.wheelDelta) { /* IE/Opera. */
                delta = event.wheelDelta/120;
                if (window.opera) { delta = -delta; }
              } else if (event.detail) { /* Mozilla case. */
                delta = -event.detail/3;
              }

              /** If delta is nonzero, handle it.
               * Basically, delta is now positive if wheel was scrolled up,
               * and negative, if wheel was scrolled down.
               */
              if (delta) {
                this.handle(delta);
              }
              if (event.preventDefault) { event.preventDefault(); }
              if (event.returnValue) { event.returnValue = false; }
              return false;
            })
            // document.getElementById("text-box").scrollTo({
            //   left: 5500,
            //   behavior: "smooth"
            // });
          }
        }
      }, immediate: true
    },
  },

  methods: {
    handle(delta) {
      document.getElementById("text-box").scrollBy(-delta*120, 0);
    },
    escape_html(string) {
      if (typeof string !== 'string') {
        return string;
      }
      return string.replace(/[&'`"<>]/g, function (match) {
        return {
          '&': '&amp;',
          "'": '&#x27;',
          '`': '&#x60;',
          '"': '&quot;',
          '<': '&lt;',
          '>': '&gt;',
        }[match]
      });
    },
  }
}
</script>

<style scoped>

.textvertical {
  height: 100%;
  overflow-x:scroll;
  float: left;
  writing-mode: tb-rl;
  writing-mode: vertical-rl;
/writing-mode: tb-rl;
  _writing-mode: tb-rl;
  -ms-writing-mode: tb-rl;            /* IE用      */
  -moz-writing-mode: vertical-rl;     /* firefox用 */
  -webkit-writing-mode: vertical-rl;  /* chrome用  */
  -o-writing-mode: vertical-rl;       /* opera用   */
}

.texthorizontal {
  width: 100%;
  overflow-y: scroll;
}
.textvertical::-webkit-scrollbar {
  height: 10px;
}
.textvertical::-webkit-scrollbar-track {
  margin: 0 2px;
  background: #ccc;
  border-radius: 5px;
}
.textvertical::-webkit-scrollbar-thumb {
  border-radius: 5px; background: #666;
}
</style>